<template>
  <div>
    <div class="mb-12">
      <v-row>
        <v-col>
          <v-card-title
            class="display-2 letter-spacing-normal font-weight-bold mb-12 align-center px-5"
          >
            Species Family
          </v-card-title>
        </v-col>

        <v-col class="px-7">
          <v-row class="align-md-center">
            <v-col>
              <v-text-field
                append-icon="$search"
                label="Search"
                v-model="search"
                class="px-5"
              />
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-data-table
        :fixed-header="true"
        class="border-radius-0 v-data-table-1 v-data-table-1--style1"
        :headers="headers"
        :items="families"
        :loading="model.fetching"
        loading-text="fetching data..."
        no-data-text="No data"
        no-results-text="Unable to find any data"
        :options.sync="pagination"
        :server-items-length="total"
      >
        <template v-slot:item.cost="{ value }"> ${{ value }}</template>
        <template v-slot:item.image="{ item }">
          <v-avatar tile class="pa-0" width="106" height="72">
            <v-img
              :src="getMedia(item)"
              lazy-src="/placeholder.jpg"
              :alt="item.name"
            />
          </v-avatar>
        </template>
        <template v-slot:item.action="{ item }">
          <v-icon @click="edit(item)">$edit</v-icon>
          <v-icon @click="remove(item)">$delete</v-icon>
        </template>
      </v-data-table>

      <v-row>
        <v-col>
          <v-card-actions class="mt-10 px-5">
            <v-btn
              depressed
              large
              color="black"
              class="white--text px-14"
              @click="newFamily()"
            >
              New Family
              <v-icon class="ml-10" right @click="createMode = true">
                $plus
              </v-icon>
            </v-btn>
          </v-card-actions>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import Model from '@models/SpeciesFamily';

export default {
  name: 'Families',
  metaInfo: {
    titleTemplate: `%s - Species Family`,
  },
  data() {
    return {
      createMode: false,
      headers: [
        { text: '', value: 'image', sortable: false, width: 250 },
        { text: 'Name', value: 'name' },
        { text: 'Action', value: 'action', sortable: false, width: 150 },
      ],
      pagination: {
        sortBy: ['created_at'],
        itemsPerPage: 10,
        page: 1,
        sortDesc: [true],
      },
      search: '',
      families: [],
      model: new Model({
        ...this.pagination,
      }),
      routeData: {},
      total: 10,
    };
  },
  watch: {
    pagination: {
      handler() {
        Object.assign(this.model, this.pagination);
        this.fetchData();
      },
      deep: true,
    },
    search() {
      this.fetchData();
    },
  },
  methods: {
    async fetchData() {
      this.syncPagination();
      let response = await this.model.get();
      if (response) {
        this.families = response.data;
        this.total = response.pagination.total;
      }
    },
    syncPagination() {
      Object.assign(this.model, this.pagination);
      (this.search &&
        this.model.setFilters({
          name: this.search,
        })) ||
        this.model.removeFilter('name');
    },
    async edit(family) {
      $router.push({
        name: 'edit-species-family',
        params: {
          id: family.id,
        },
      });
    },
    async remove(families) {
      if (!(await $question('Are you sure, you want to delete this family?'))) {
        return;
      }
      if (await this.model.delete(families.id)) {
        $showSuccess('Family has been removed.', 'delete-families');
        this.fetchData();
      }
    },
    newFamily() {
      this.$router.push({
        name: 'new-species-family',
      });
    },
  },
  mounted() {
    this.fetchData();
  },
};
</script>
